import React, { useContext } from 'react'

import AppContext from '../../components/App/context'
import InfoBox from '../../components/InfoBox'

import { getPostTypeConfig as getFilePostTypeConfig } from '../image'

import getConstants from './constants'
import Content from './Content'
import New from './New'

function getPostTypeConfig() {
    const r = getFilePostTypeConfig({ name: 'referenceLetter', getConstants })
    return {
        ...r,
        userPageFunctions: (p) => {
            return {
                ...r.userPageFunctions({
                    ...p,
                    nsPageProps: {
                        type: 'list',
                        BeforePostsComponent: () => {

                            const name = 'referenceLetter'

                            const appContext = useContext(AppContext)

                            return (
                                <InfoBox
                                    title={appContext.labels[name + 'ListInfoTitle']}
                                    content={appContext.messages[name + 'ListInfoContent']}
                                />
                            )
                        }
                    }
                }),
                addMenuItems: () => []
            }
        },
        getPages: function() {
            return {
                ...r.getPages(),
                new: New
            }
        },
        getComponent: (p) => {
            return r.getComponent({
                ...p, pages: {
                    content: Content,
                    new: New
                }
            })
        }
    }
}

export default getPostTypeConfig()
